// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LCHK","questions":"styles_questions__3ZtiA","footer":"styles_footer__2ZBym"};